////////////////////////////////////////////////////////////////////////////////
//                                                                            //
//  IRONSIDE - Public Website GUI                                             //
//                                                                            //
//  Version: 1.0.1                                                            //
//  Summary: Responsive, lazy-loaded image — the base every media component uses //
//                                                                            //
////////////////////////////////////////////////////////////////////////////////

import type { ImgHTMLAttributes } from 'react';

export interface ImgProps extends ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  /** Alt text is REQUIRED, not optional — a decorative image should say so
   * explicitly (`alt=""`) rather than omit the prop and let it be forgotten. */
  alt: string;
}

export function Img ({ src, alt, loading = 'lazy', decoding = 'async', ...rest }: ImgProps) {
  return <img src={src} alt={alt} loading={loading} decoding={decoding} {...rest} />;
}
